import { render, staticRenderFns } from "./servico-suspenso.vue?vue&type=template&id=0e2f6e5a&"
import script from "./servico-suspenso.vue?vue&type=script&lang=js&"
export * from "./servico-suspenso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports